export {
  AutoRefreshToken, autoRefreshTokenInstance
} from './src/index';
